import { create } from "zustand";
import { persist } from "zustand/middleware";

// import fetchRepoData from "./fetchRepoData";
import initialState from "./initialState";
import organismSlice from "./organismSlice";
import neurodynamicsSlice from "./neurodynamicsSlice";
import connectomicsSlice from "./connectomicsSlice";
import compNeuroSlice from "./compNeuroSlice";
import projectionsSlice from "./projectionsSlice";
import share from "./share";

// -----------------------------------------------------------------------------

const useBrainStore = create(
  // using persist to save user data to localStorage
  persist(
    (set, get) => ({
      // ...fetchRepoData(set),
      ...initialState,
      ...organismSlice(set),
      ...neurodynamicsSlice(set, get),
      ...connectomicsSlice(set, get),
      ...compNeuroSlice(set),
      ...projectionsSlice(set),
      ...share(get),

      // -----------------------------------------------------------------------------

      // SUMMARY CALCULATIONS
      // Calculate totals based on all values
      // getTimeToEmulation: () => get().yearsToCompletion + 1,

      // TODO: do some rounding or conversion between billions and millions, depending on expected values
      // getTotalCost: () => (1.2 - get().investment / 1000).toFixed(2),

      // -----------------------------------------------------------------------------

      // RESET
      // For the 'Reset All' button
      resetAll: () =>
        set(() => ({
          ...initialState,
          // Reset to one default experiment
          neurodynamicsExperimentsArr: [
            initialState.neurodynamicsExperimentsArr[0],
          ],
          connectomicsExperimentsArr: [
            initialState.connectomicsExperimentsArr[0],
          ],
          // Explicitly reset the counter
          neurodynamicsExpCounter: initialState.neurodynamicsExpCounter,
          connectomicsExpCounter: initialState.connectomicsExpCounter,
        })),
    }),
    {
      // name in localStorage
      name: "brainEm-storage",
    }
  )
);

useBrainStore.subscribe((newState) => {
  console.log("Zustand store changed:", newState);
});

export default useBrainStore;
